import { ModelEditPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$owner/players/$id/edit')(
  {
    component: RouteComponent
  }
);

function RouteComponent() {
  const { id: modelId } = Route.useParams();

  return <ModelEditPage model="player" modelId={modelId} />;
}
